import axios from "axios";

export const checkVerification = (data) => {
  return axios.get(`${process.env.REACT_APP_FLEXAPP}/os/checkVerification?phone=${data.phone}&code=${data.code}`);
}

export const sendVerification = (phone) => {
  return axios.get(`${process.env.REACT_APP_FLEXAPP}/os/sendVerification?phone=${phone}`);
}
